// frontend/src/utils/supplierApi.js

import { apiFetch } from './api'; // 🌟 既存の共通関数をインポート

// エンドポイントのパス（api.js 側でベースURLが付与されるためパスのみ）
const SUPPLIERS_ENDPOINT = '/suppliers';

export const getSuppliers = async () => {
  const response = await apiFetch(`${SUPPLIERS_ENDPOINT}/`);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || '仕入先の取得に失敗しました');
  }
  return response.json();
};

export const createSupplier = async (supplierData) => {
  const response = await apiFetch(`${SUPPLIERS_ENDPOINT}/`, {
    method: 'POST',
    body: JSON.stringify(supplierData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || '仕入先の登録に失敗しました');
  }
  return response.json();
};

export const updateSupplier = async (uuid, supplierData) => {
  const response = await apiFetch(`${SUPPLIERS_ENDPOINT}/${uuid}`, {
    method: 'PUT',
    body: JSON.stringify(supplierData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || '仕入先の更新に失敗しました');
  }
  return response.json();
};

export const deleteSupplier = async (uuid) => {
  const response = await apiFetch(`${SUPPLIERS_ENDPOINT}/${uuid}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || '仕入先の削除に失敗しました');
  }
  return response.json();
};